import React, { useState } from "react";
import { Paginator } from 'primereact/paginator';

export default function Paginador( { theFirst , theRecords , setTheRows }) {
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(10);
    const [records,setRecord] = useState( 0 )

    useState(() => {

        setFirst( theFirst)

    } , [theFirst])

    useState(() => {
        //setRows( theRecords)
    } , [theRecords])

    // 
    //{first: 0, rows: 20, page: 0, totalPages: 12}

    const onPageChange = (event) => {

        console.log( "onPageChange " , event )

        setFirst(event.first);
        setRows(event.rows);
        setTheRows( event )
        //console.log( "rowPerpage = " , event.rowsPerPageOptions )
    };

    return (
        <div className="card">
            <Paginator first={first} rows={rows} totalRecords={theRecords} rowsPerPageOptions={[10, 20, 30]} onPageChange={onPageChange} />
        </div>
    );
}